module.exports = __webpack_public_path__ + "static/media/img_frame.39b708c9.svg";